import ChangeTargetComment from './ChangeTargetComment';
import ChangeTargetForm from './ChangeTargetForm';
import getTarget from './util';

export default {
  label: 'Change Target',
  value: 'Change Target',
  Form: ChangeTargetForm,
  Comment: ChangeTargetComment,
  initialState(campaign) {
    const { targetKpi, targetKpiValue } = getTarget(campaign);
    return { targetKpi, targetKpiValue };
  },
  patch(campaign, change) {
    const { targetKpi, targetKpiValue } = change;
    return { targetKpi, targetKpiValue };
  },
};
